import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../../components/ui/dialog';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import { ROLES } from './constants';

const CreateInvitationDialog = ({
  open,
  onOpenChange,
  formData,
  setFormData,
  submitting,
  onSubmit,
  agencyName,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="create-invitation-dialog">
      <DialogHeader>
        <DialogTitle>Invite New Staff Member</DialogTitle>
        <DialogDescription>
          Send an invitation email to join {agencyName || 'your agency'}.
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-4">
        <div>
          <Label>Email Address *</Label>
          <Input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="user@example.com"
            data-testid="invite-email-input"
          />
        </div>

        <div>
          <Label>Full Name *</Label>
          <Input
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="John Smith"
            data-testid="invite-name-input"
          />
        </div>

        <div>
          <Label>Role</Label>
          <Select
            value={formData.role}
            onValueChange={(v) => setFormData({ ...formData, role: v })}
          >
            <SelectTrigger data-testid="invite-role-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ROLES.map((role) => (
                <SelectItem key={role} value={role}>
                  {role}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label>Expires In (Days)</Label>
          <Select
            value={formData.expires_in_days.toString()}
            onValueChange={(v) =>
              setFormData({ ...formData, expires_in_days: parseInt(v, 10) })
            }
          >
            <SelectTrigger data-testid="invite-expires-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="1">1 day</SelectItem>
              <SelectItem value="3">3 days</SelectItem>
              <SelectItem value="7">7 days</SelectItem>
              <SelectItem value="14">14 days</SelectItem>
              <SelectItem value="30">30 days</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label>Personal Message (Optional)</Label>
          <Input
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            placeholder="Welcome to the team!"
            data-testid="invite-message-input"
          />
        </div>
      </div>

      <DialogFooter className="mt-6">
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button onClick={onSubmit} disabled={submitting} data-testid="send-invitation-btn">
          <PaperPlaneTilt size={16} className="mr-2" />
          {submitting ? 'Sending...' : 'Send Invitation'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CreateInvitationDialog;
